import useragent from '@common/useragent'
import dialog from '@common/dialog'
import urlParser from '@common/url'

const DOWNLOAD_IOS = 'https://itunes.apple.com/zh/app/id372353614?l=zh&ls=1&mt=8' // IOS下载地址
const DOWNLOAD_ANDRIOD = 'http://a.app.qq.com/o/simple.jsp?pkgname=com.mymoney' // 应用宝地址
const ua = navigator.userAgent.toLowerCase()
const isWeiXin = ua.indexOf('micromessenger') !== -1 // 微信
const isWeibo = ua.indexOf('weibo') !== -1 // 微博
const isSafari = ua.indexOf('safari') !== -1 // safari浏览器

/**
 * 下载提示窗
 * cancelCallback: 点击取消按钮的回调
 */
const fnDownloadApp = (cancelCallback) => {

  dialog({
    msg: '赶紧打开随手记APP使用哦~',
    confirmText: '立即打开',
    handleConfirm() {
      if (isWeiXin || !useragent.isIOS) {
        window.location.href = DOWNLOAD_ANDRIOD
      } else {
        window.location.href = DOWNLOAD_IOS
      }
    },
    handleCancel() {
      if (cancelCallback) {
        try {
          cancelCallback()
        } catch (e) {
          console.log(e)
        }
      }
    }
  })
}

/**
 * 唤醒随手记
 * url: 唤醒随手记后跳转的地址
 */
const evokeApp = (url) => {
  let openUrl
  if (url === 'market') {
    // 如果参数是market，则表示跳转到原生理财首页
    if (useragent.isIOS) {
      openUrl = 'FDMoneyAny://launch.feidee.com/requestGoToUrl/?p=%7b%22type%22%3a%22ActivityNavigation%22%2c%22url%22%3a%2210%22%7d'
    } else {
      openUrl = 'fdmoneyall://launch.feidee.com/ActivityNavigation?url=46'
    }
  } else {
    openUrl = `fdmoneyany://forumWeb.feidee.com/FinanceMarket?url=${encodeURIComponent(url)}`
  }
  if (isSafari) {
    window.location.href = openUrl
  } else {
    const iframe = document.createElement('iframe')
    iframe.src = openUrl
    iframe.style.display = 'none'
    document.body.appendChild(iframe)
  }
}

/**
 * 唤醒方法
 * url: 唤醒APP后跳转的页面地址,默认为当前页面
 */
export const open = (url = window.location.href) => {
  if (useragent.isSuishouji || useragent.isSuiguanjia || useragent.isKaniu || useragent.isYunzhijia) {
    console.log('This page is in myapp')
  } else if (isWeiXin || isWeibo) {
    fnDownloadApp()
  } else {
    evokeApp(url)
    // 600毫秒后显示下载提示弹窗
    setTimeout(fnDownloadApp, 600)
  }
}

/**
 * 唤醒方法
 * url: 唤醒APP后跳转的页面地址,默认为当前页面
 */
export const wakeUp = (
  url = window.location.href,
  { forceWakeUp = false, showDownloadModal = true, cancelWakeUp = () => {}, backup = () => {} } = {}) => {
  if (useragent.isSuishouji || useragent.isSuiguanjia || useragent.isKaniu || useragent.isYunzhijia) {
    console.log('该页面在app中，无需唤醒')
    backup.call(null)
  } else if (forceWakeUp) {
    evokeApp(url)
    if (showDownloadModal) {
      setTimeout(() => {
        fnDownloadApp(cancelWakeUp)
      }, 600)
    }
  } else if (isWeiXin) {
    console.log('该页面在微信中，无需唤醒')
    backup.call(null)
  } else if (urlParser('?huanxing')) {
    evokeApp(url)
    if (showDownloadModal) {
      setTimeout(() => {
        fnDownloadApp(cancelWakeUp)
      }, 600)
    }
  } else {
    console.log('页面没带唤醒参数，无需唤醒')
    backup.call(null)
  }
}

/**
 * 需要确认是否唤醒
 * options.url: 跳转的页面地址,默认为当前页面
 * options.callback: 取消唤醒的回调函数
 */
export const confirm = ({
  url = window.location.href,
  showDownload = true,
  callback = () => {}
}) => {
  if (useragent.isSuishouji || useragent.isSuiguanjia || useragent.isKaniu || useragent.isYunzhijia || !urlParser('?huanxing')) {
    try {
      callback()
    } catch (e) {
      console.log(e)
    }
  } else {
    evokeApp(url)
    // safari因为要选择是否唤起随手记，默认会显示下载弹窗，点击“取消”时执行回调，
    // 如果页面不需要跳转，可以设置showDownload为false，这样不会显示下载弹窗
    if (useragent.isIOS && isSafari && showDownload) {
      setTimeout(() => {
        fnDownloadApp(callback)
      }, 600)
    } else {
      setTimeout(() => {
        try {
          callback()
        } catch (e) {
          console.log(e)
        }
      }, 600)
    }
  }
}

export default {
  open,
  confirm
}



// WEBPACK FOOTER //
// ./node_modules/@common/client/src/openApp.js